export const frontmatter = {
    "draft": true,
    "title": "Main Endpoints",
    "description": "OnnIA API endpoints reference.",
    "sidebar_label": "Endpoints",
    "sidebar_group": "reference",
    "sidebar_order": 2
}

export const toc = [
    {
        "depth": 2,
        "id": "messaging-endpoints",
        "value": "Messaging Endpoints"
    },
    {
        "depth": 2,
        "id": "workflows-endpoints",
        "value": "Workflows Endpoints"
    },
    {
        "depth": 2,
        "id": "tickets-endpoints",
        "value": "Tickets Endpoints"
    }
]